import HorizontalBarChart from '../../charts/horizontalBarChart'
import ApiService from '../../../../../../services/ApiService'
import { use } from 'echarts/core'
import { CanvasRenderer } from 'echarts/renderers'
import { GaugeChart } from 'echarts/charts'
import {
  TitleComponent,
  TooltipComponent,
  LegendComponent,
} from 'echarts/components'
import VChart, { THEME_KEY } from 'vue-echarts'

use([
  CanvasRenderer,
  GaugeChart,
  TitleComponent,
  TooltipComponent,
  LegendComponent,
])

export default {
  props: {
    filterProp: Object,
  },
  components: {
    HorizontalBarChart,
    VChart,
  },
  provide: {
    [THEME_KEY]: 'light',
  },
  data() {
    return {
      apiService: new ApiService(),
      loading: false,
      showChart: true,
      adhesionCalleds: [],
      page: 1,
      exampleValue: 50,
      totalPages: 1,
      pageSize: 7,
      val: 5,
      percent: 0,
      options: {
        maintainAspectRatio: false,
        responsive: true,
        legend: {
          labels: {
            usePointStyle: true,
          },
        },
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
              },
            },
          ],
          xAxes: [
            {
              ticks: {
                beginAtZero: true,
              },
            },
          ],
        },
      },
      optionsGauge: {
        series: [
          {
            type: 'gauge',
            axisLine: {
              lineStyle: {
                width: 10,
                color: [
                  [0.3, '#ED8990'],
                  [0.7, '#FDB578'],
                  [1, '#BCD504'],
                ],
              },
            },
            pointer: {
              itemStyle: {
                color: 'auto',
              },
            },
            axisTick: {
              distance: -20,
              length: 5,
              lineStyle: {
                color: '#fff',
                width: 1,
              },
            },
            splitLine: {
              distance: -20,
              length: 20,
              lineStyle: {
                color: '#fff',
                width: 3,
              },
            },
            axisLabel: {
              color: 'auto',
              distance: 15,
              fontSize: 10,
            },
            detail: {
              valueAnimation: true,
              formatter: '{value} %',
              color: 'auto',
              fontSize: 10,
            },
            data: [
              {
                value: 0,
              },
            ],
            legend: {
              labels: {
                usePointStyle: true,
              },
            },
          },
        ],
      },
      adhesionChartData: {},
      calleds: [],
      calledsOthers: [],
      labels: [],
      headerProps: {
        sortByText: 'Ordenar por',
      },
      header: [
        {
          text: '',
          align: 'center',
          value: '',
        },
        {
          text: 'Corretivas Abertas Por Módulo de Chamados',
          align: 'center',
          value: 'calleds',
        },
        {
          text: 'Corretivas Abertas Por Outros Canais',
          align: 'center',
          value: 'others',
        },
        {
          text: '% O.S. Corretivas Abertas Via Chamados',
          align: 'center',
          value: 'percent',
        },
      ],
      total: 0,
    }
  },
  async created() {
    this.listCalleds()
  },
  methods: {
    requestExcel() {
      this.filterProp.pageSize = 10000
      let now = new Date()
      var filename = `adhesion_Called_${now.getDate()}-${
        now.getMonth() + 1
      }-${now.getFullYear()}.xlsx`
      this.apiService
        .post('excel/adhesionCalled', this.filterProp)
        .then((response) => {
          response = `data:application/octet-stream;base64,${response.content}`
          const link = document.createElement('a')
          link.href = response
          link.setAttribute('download', filename)
          document.body.appendChild(link)
          link.click()
        })
    },
    async listCalleds() {
      await this.apiService
        .post('reports/adhesionCalled', this.filterProp)
        .then((response) => {
          this.adhesionCalleds = []
          this.calleds = []
          this.calledsOthers = []

          this.total =
            response.content.abertasChamado + response.content.abertasOutros
          // if (response.content.objects) {
          //   this.showChart = response.content.objects.length > 0;
          // }

          this.calleds.push(response.content.abertasChamado)
          this.calledsOthers.push(response.content.abertasOutros)
          this.percent = response.content.porcentagem

          this.adhesionCalleds.push({
            calleds: response.content.abertasChamado,
            others: response.content.abertasOutros,
            percent: response.content.porcentagem,
          })
        })
        .catch((err) => {})

      this.fillAdhesionCalledChartData()
    },
    fillAdhesionCalledChartData() {
      this.adhesionChartData = {
        labels: [''],
        datasets: [
          {
            label: this.$t('Via Chamados'),
            data: this.calleds,
            backgroundColor: '#87AFA6',
          },
          {
            label: this.$t('Outros Canais'),
            data: this.calledsOthers,
            backgroundColor: '#BAB3D3',
          },
        ],
      }
    },
  },
  watch: {
    page() {
      this.filterProp.page = this.page
      this.listCalleds()
    },
    percent(nv, ov) {
      this.optionsGauge.series[0].data[0].value = nv
    },
  },
}
